import { Iot$ } from '../../../mod/Iot$';

type Callback = () => void;

export const awsIotSubscription = {
    useOutletUpdate(outletId: number, callback: Callback) {
        Iot$.useSubscribe(outletId && `outlet/${outletId}/update`, callback);
    },

    useZoneUpdate(zoneId: number, callback: Callback) {
        Iot$.useSubscribe(zoneId && `zone/${zoneId}/update`, callback);
    },

    useOrderUpdate(orderId: number, callback: Callback) {
        Iot$.useSubscribe(`order/${orderId}/update`, callback);
    },
};
